// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';

interface PatchUserMailRequest {
  currentEmail: string;
  password: string;
  newEmail: string;
}

export const useMailChange = () => {
  const patchUserMail = (_data: PatchUserMailRequest): Promise<void> => rejectServiceClosed();

  return { patchUserMail };
};
